import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Check, Calendar, Mail, House } from "lucide-react";
import { Reveal } from "../components/Chrome";
import { HOST, OSCAR_URL, WEBINAR } from "../content";

const NEXT_STEPS = [
  { icon: Mail, title: "Check Your Email", desc: "Your confirmation and calendar details are on their way. Add the event so you don't miss it." },
  { icon: Calendar, title: "Mark the Date", desc: "September 10th, 2026 at 6:00 PM EST — live, with open Q&A at the end." },
  { icon: Check, title: "Come With Questions", desc: "Entitlement, credit, timeline — bring anything. That's what the live Q&A is for." },
];

export default function ThankYou() {
  useEffect(() => {
    document.title = "You're Registered — VA Purchasing Power";
    return () => { document.title = "Oscar Tobar | VA Purchasing Power | Free Webinar"; };
  }, []);

  return (
    <div className="relative min-h-screen flex flex-col" data-testid="thank-you-page">
      <div className="flex-1 max-w-[760px] mx-auto px-6 pt-24 md:pt-32 pb-20 text-center">
        <Reveal>
          <div className="w-20 h-20 rounded-full bg-[#5D8FC4] mx-auto flex items-center justify-center">
            <Check className="w-10 h-10 text-[#070B11]" strokeWidth={3} />
          </div>
          <p className="font-mono-c text-[11px] tracking-[0.35em] text-[#5D8FC4] uppercase mt-8">Registration Confirmed</p>
          <h1 className="mt-4 uppercase font-black tracking-[-0.02em] leading-[1.02] text-4xl md:text-5xl">
            Your Seat Is <span className="text-[#5D8FC4]">Reserved.</span>
          </h1>
          <p className="mt-5 text-white/55 text-[15px] leading-relaxed max-w-xl mx-auto">
            You're in for the free live briefing on <span className="text-[#EDF2F7]">September 10th, 2026 at 6:00 PM EST</span>.
            No obligation, no hard credit pull — just your exact $0-down VA purchasing power, explained.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-4 text-left">
          {NEXT_STEPS.map((s, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="audience-card p-6 h-full" data-testid={`thankyou-step-${i + 1}`}>
                <s.icon className="w-6 h-6 text-[#5D8FC4]" strokeWidth={1.8} />
                <h3 className="mt-4 font-black uppercase text-sm">{s.title}</h3>
                <p className="mt-2 text-[13px] text-white/50 leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-12 flex items-center justify-center gap-4 border border-white/10 bg-white/[0.02] p-5 max-w-md mx-auto text-left" data-testid="thankyou-host-card">
            <img src={OSCAR_URL} alt={HOST.name} className="w-14 h-14 rounded-full border-2 border-[#5D8FC4] object-cover shrink-0" />
            <div>
              <p className="font-bold text-sm">{HOST.name}</p>
              <p className="text-xs text-white/50">{HOST.company} · {HOST.nmls}</p>
              <p className="text-xs text-white/55 mt-1">See you live — bring your questions.</p>
            </div>
          </div>
          <Link to="/" className="inline-block mt-10 font-mono-c text-[11px] tracking-[0.2em] text-white/50 hover:text-[#5D8FC4] transition-colors duration-200 underline decoration-white/20" data-testid="thankyou-home-link">
            ← BACK TO THE MAIN PAGE
          </Link>
        </Reveal>
      </div>

      <footer className="border-t border-white/10 px-6 py-8">
        <p className="max-w-[760px] mx-auto flex items-center justify-center gap-2 font-mono-c text-[10px] text-white/25 tracking-widest text-center">
          <House className="w-4 h-4" strokeWidth={1.5} />
          © 2026 Great Western Funding · Equal Housing Lender · NMLS# 667612 · Company NMLS# 2739318
        </p>
      </footer>
    </div>
  );
}
